import { useRef, useState } from "react";

export default function GHEmailTrigger() {
  const shareLaunchRef = useRef(false);
  const [isSharing, setIsSharing] = useState(false);

  const handleShare = (growthHackInfo, serviceTags) => {
    if (shareLaunchRef.current) {
      console.log('[Share] Ignored duplicate click while launching mail client.');
      return;
    }
    shareLaunchRef.current = true;
    setIsSharing(true);
    
    const info = growthHackInfo || {};
    const clientName = info.ClientName || info.AccountName || 'N/A';
    const title = info.GrowthHackTitleGenAI || info.GrowthHackTitle || 'Untitled Growth Hack';
    let description = (info.GrowthHackSummaryGenAI || '').trim();
    // Convert '##' markers into new line separators
    if (description.includes('##')) {
      // Remove leading markers, convert markers to single newlines
      description = description
        .replace(/^(\s*##\s*)+/, '')
        .replace(/\s*##\s*/g, '\n');
    }
    // Collapse multiple blank lines to a single newline and trim right spaces
    description = description
      .replace(/\n{2,}/g, '\n')
      .split('\n')
      .map(l => l.trimEnd())
      .join('\n');

    // Add special symbols before up to the first five description lines
    if (description) {
      const arrow = '➤';
      const dLines = description.split('\n').filter(l => l.trim().length > 0);
      description = dLines.map(line => `${arrow} ${line}`).join('\n');
    }
    const eyServiceTags = (info.EYServiceGenAI || '').trim();
    const score = (info.GrowthHackScore != null ? info.GrowthHackScore : 'N/A');
    const id = (info.GrowthHackID != null ? info.GrowthHackID : 'N/A');

    // Optional: derive service tags from processed serviceTags memo if EYServiceGenAI missing
    const derivedServiceTags = (!eyServiceTags && Array.isArray(serviceTags))
      ? serviceTags.map(t => t.title).join(', ') : '';

    const sections = [
      ['Client', clientName],
      ['Growth Hack Title', title],
      description && ['Growth Hack Description', description],
      (eyServiceTags || derivedServiceTags) && ['EY Service Tags', (eyServiceTags || derivedServiceTags)],
      ['Growth Hack Score', String(score)],
    ].filter(Boolean);

    const lines = [];
    sections.forEach(([label, value]) => {
      const val = (value || '').toString();
      if (!val.trim()) return; // skip empty
      lines.push(`${label}:`);        // heading line
      lines.push(val);                // value line (can include internal newlines already)
      lines.push('');                 // blank separator
    });

    const body = lines.join('\n');
    const to = "";
    const subject = `Growth Hack alert notification ||  ${clientName}`;

    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const mailtoLink = `mailto:${to ? encodeURIComponent(to) : ''}${params.length ? `?${params.join('&')}` : ''}`;

    console.log('[Share] mailto link length (raw):', mailtoLink.length, mailtoLink);
    try {
      const a = document.createElement('a');
      a.href = mailtoLink;
      a.style.display = 'none';
      a.setAttribute('target', '_self');
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        if (a.parentNode) a.parentNode.removeChild(a);
        shareLaunchRef.current = false;
        setIsSharing(false);
      }, 800);
    } catch (e) {
      console.warn('[Share] Error launching mail client:', e);
      shareLaunchRef.current = false;
      setIsSharing(false);
    }
  };

  return { handleShare, isSharing };
}
